// src/HeatmapDirectory.js
import React from 'react';
import { Link } from 'react-router-dom';
import VantaLayout from './componets/vantalayout';
import './HeatmapDirectory.css';

function HeatmapDirectory() {
  return (
    <VantaLayout>
      <div className="heatmap-directory">
        <h1>Market Heatmaps</h1>
        <div className="heatmap-links">
          <Link to="/heatmaps/stocks" className="heatmap-link">
            <h2>Stocks</h2>
          </Link>
          <Link to="/heatmaps/crypto" className="heatmap-link">
            <h2>Crypto</h2>
          </Link>
          <Link to="/heatmaps/etf" className="heatmap-link">
            <h2>ETFs</h2>
          </Link>
          <Link to="/heatmaps/forex" className="heatmap-link">
            <h2>Forex</h2>
          </Link>
        </div>
      </div>
    </VantaLayout>
  );
}

export default HeatmapDirectory;
